import { Box, useMediaQuery, useTheme } from '@mui/material';
import {
  ButtonV2,
  TextV2,
  TextV2Colour,
} from '@insights-ltd/design-library/components';
import PermissionGuard from 'components/PermissionGuard';
import { ReactNode } from 'react';

type ProfileCardHeaderProps = {
  profileTitle: string;
  actionText: string;
  actionColor?: string;
  profileTitleColor?: TextV2Colour;
  onActionClick: () => void;
  children?: ReactNode;
};

const ProfileCardHeader = ({
  profileTitle,
  actionText,
  actionColor,
  profileTitleColor,
  onActionClick,
  children,
}: ProfileCardHeaderProps) => {
  const localTheme = useTheme();
  const isMobileScreen = useMediaQuery(() => localTheme.breakpoints.down('md'));

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <TextV2 variant="h4" color={profileTitleColor ?? 'primary'}>
          {profileTitle}
        </TextV2>

        <PermissionGuard
          requiredPermissions={[{ action: 'PurchaseProfiles', scope: 'Local' }]}
        >
          <ButtonV2
            sx={{
              '&.MuiButtonBase-root': {
                padding: isMobileScreen ? '0 0 0 0.5rem' : '0.1rem 0 0 0.5rem',
                minWidth: 'auto',
                border: 'none',
                color: actionColor,
                lineHeight: '1.625rem',
                fontWeight: '600',
                fontSize: '1rem',
              },
            }}
            buttonText={actionText}
            buttonVariant="outlined"
            onClick={onActionClick}
          />
        </PermissionGuard>
      </Box>
      {children}
    </Box>
  );
};

export default ProfileCardHeader;
